<template>
  <div class="create-group-element-wrapper">{{text}}</div>
</template>

<script>
export default {
  name: "CreateGroupElement",
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  computed: {
    text() {
      return this.getGroupTipContent(this.payload);
    },
  },
  methods: {
    getGroupTipContent(payload) {
      return `${payload.extension}`;
    },
  },
};
</script>

<style scoped>
.create-group-element-wrapper {
  background: #fff;
  padding: 4px 15px;
  margin-bottom: 10px;
  border-radius: 3px;
  color: #a5b5c1;
  font-size: 12px;
}
</style>
